import { ILaya } from "../../ILaya";
import { URL } from "../net/URL";
import { PAL } from "../platform/PlatformAdapters";
import { Browser } from "../utils/Browser";
import { Utils } from "../utils/Utils";
import { VideoPlayerBackend } from "./VideoPlayerBackend";
export class HTMLVideoPlayer extends VideoPlayerBackend {
    constructor() {
        super();
        this.element = HTMLVideoPlayer.createElement();
    }
    get currentTime() {
        return this.element.currentTime;
    }
    set currentTime(value) {
        this.element.currentTime = value;
    }
    get volume() {
        return this.element.volume;
    }
    set volume(value) {
        this.element.volume = value;
    }
    get readyState() {
        return this.element.readyState;
    }
    get duration() {
        return this.element.duration;
    }
    get ended() {
        return this.element.ended;
    }
    get loop() {
        return this.element.loop;
    }
    set loop(value) {
        this.element.loop = value;
    }
    get playbackRate() {
        return this.element.playbackRate;
    }
    set playbackRate(value) {
        this.element.playbackRate = value;
    }
    get muted() {
        return this.element.muted;
    }
    set muted(value) {
        this.element.muted = value;
    }
    onLoad(url) {
        var _a;
        this.element.controls = (_a = this.options.controls) !== null && _a !== void 0 ? _a : false;
        HTMLVideoPlayer.setSrc(this.element, url);
        if (this.options.underGameView) {
            let c = Browser.container;
            if (c !== Browser.document.body)
                Browser.document.body.insertBefore(this.element, c);
            else
                Browser.document.body.appendChild(this.element);
        }
        else
            Browser.document.body.appendChild(this.element);
        this.onTransformChanged();
        this.setLoaded();
    }
    onPlay() {
        this.element.play().catch(e => {
            if (e.name === "NotAllowedError")
                PAL.media.resumeUntilGotFocus(this);
            else
                console.warn(e);
        });
    }
    onPause() {
        this.element.pause();
    }
    onTransformChanged() {
        let { x, y, width, height } = this.getNodeTransform();
        let style = this.element.style;
        style.left = x + "px";
        style.top = y + "px";
        style.width = width + "px";
        style.height = height + "px";
        PAL.browser.setStyleTransform(style, "rotate(" + (ILaya.stage.canvasDegree) + "deg)");
    }
    onDestroy() {
        HTMLVideoPlayer.setSrc(this.element, null);
        this.element.remove();
    }
    static createElement() {
        let ele = Browser.createElement("video");
        let style = ele.style;
        style.position = 'absolute';
        style.top = '0px';
        style.left = '0px';
        PAL.browser.setStyleTransformOrigin(style, "0 0");
        ele.setAttribute('crossorigin', 'anonymous');
        if (Browser.onMobile) {
            ele["x5-playsInline"] = true;
            ele["x5-playsinline"] = true;
            ele.x5PlaysInline = true;
            ele.playsInline = true;
            ele["webkit-playsInline"] = true;
            ele["webkit-playsinline"] = true;
            ele.webkitPlaysInline = true;
            ele.playsinline = true;
            ele.style.playsInline = true;
            ele.crossOrigin = "anonymous";
            ele.setAttribute('playsinline', 'true');
            ele.setAttribute('x5-playsinline', 'true');
            ele.setAttribute('webkit-playsinline', 'true');
            ele.autoplay = true;
        }
        return ele;
    }
    static setSrc(ele, url) {
        while (ele.childElementCount)
            ele.firstChild.remove();
        if (url) {
            if (url.startsWith("blob:"))
                ele.src = url;
            else {
                let sourceElement = Browser.createElement("source");
                sourceElement.src = URL.postFormatURL(URL.formatURL(url));
                let extension = Utils.getFileExtension(url);
                sourceElement.type = extension == "m3u8" ? "application/vnd.apple.mpegurl" : ("video/" + extension);
                ele.appendChild(sourceElement);
            }
        }
        else {
            ele.pause();
            ele.src = "";
        }
    }
}
